import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { NetworkGroupResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { asUpdateHook, buildSelectParam, get, post, postEmpty } from "./common";

export const networkGroup = {
    record() {
        return get<NetworkGroupResponseTypes.Record>(`/network-group/record`);
    },
    create(data: typeof Requests.NetworkGroup.Create.Input) {
        return post<typeof data>(`/network-group/create`, data);
    },
    obtain(id: string) {
        return get<NetworkGroupResponseTypes.Obtain>(`/network-group/obtain/${id}`);
    },
    delete(id: string) {
        return postEmpty(`/network-group/delete/${id}`);
    },
    formHooks: {
        select: (async (param?: SelectParam) => {
            const req = get<NetworkGroupResponseTypes.Select>(
                `/network-group/select` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.NetworkGroup.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/network-group/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
